<template>

    <b-card>
        <b-card-body>
            <h4 class="mb-4">Edit Registrant Information</h4>

            <b-form-row>
                <b-col>
                    <b-form-group>
                        <label>First Name <span class="required">*</span></label>
                        <b-form-input v-model="registration.firstName"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <label>Last Name <span class="required">*</span></label>
                    <b-form-input v-model="registration.lastName"></b-form-input>
                </b-col>
            </b-form-row>

            <b-form-row class="mt-2">
                <b-col>
                    <label>Phone Number <span class="required">*</span></label>
                    <b-form-input v-model="registration.phoneNumber" v-mask="'(###) ###-####'"></b-form-input>
                </b-col>
                <b-col cols="8">
                    <label>Email Address <span class="required">*</span></label>
                    <b-form-input type="email" v-model="registration.emailAddress"></b-form-input>
                </b-col>
            </b-form-row>

            <b-form-row class="mt-3">
                <b-col>
                    <b-form-checkbox class="text-muted" v-model="registration.receiveSms" value="true" unchecked-value="false">Receive text-message updates (standard rates apply)</b-form-checkbox>
                </b-col>
            </b-form-row>

            <b-form-row class="mt-4">
                <b-col cols="9">
                    <label>Address <span class="required">*</span></label>
                    <b-form-input v-model="registration.address1"></b-form-input>
                </b-col>
                <b-col>
                    <label>Apt, suite, etc.</label>
                    <b-form-input v-model="registration.address2"></b-form-input>
                </b-col>
            </b-form-row>

            <b-form-row class="mt-2">
                <b-col cols="4">
                    <label>City <span class="required">*</span></label>
                    <b-form-input v-model="registration.city"></b-form-input>
                </b-col>
                <b-col cols="4">
                    <label>State <span class="required">*</span></label>
                    <b-form-select v-model="registration.state">
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                    </b-form-select>
                </b-col>
                <b-col cols="4">
                    <label>Zip <span class="required">*</span></label>
                    <b-form-input v-model="registration.zip" v-mask="'#####-####'"></b-form-input>
                </b-col>
            </b-form-row>

            <!--                <div v-if="registration.conference.waEdu === 'true'">-->
            <!--                    <h5 class="mt-5 mb-4">Washington School Information</h5>-->

            <!--                    <b-form-row class="mt-2">-->
            <!--                        <b-col cols="6">-->
            <!--                            <b-form-group>-->
            <!--                                <label>District <span class="required">*</span></label>-->
            <!--                                <b-form-select v-model="registration.district">-->
            <!--                                    <option value="0">Not Listed/Not Applicable</option>-->
            <!--                                    <option :value="dist.code" v-for="dist in districts">{{dist.name}} ({{dist.city | capitalize}})</option>-->
            <!--                                </b-form-select>-->
            <!--                            </b-form-group>-->
            <!--                        </b-col>-->
            <!--                        <b-col cols="6">-->
            <!--                            <b-form-group>-->
            <!--                                <label>School <span class="required">*</span></label>-->
            <!--                                <b-form-select v-model="registration.school">-->
            <!--                                    <option value="0">Not Listed/Not Applicable</option>-->
            <!--                                    <option :value="school.code" v-for="school in schools">{{school.name}} ({{school.city | capitalize}})</option>-->
            <!--                                </b-form-select>-->
            <!--                            </b-form-group>-->
            <!--                        </b-col>-->
            <!--                    </b-form-row>-->
            <!--                </div>-->

            <!--                    <div v-if="registration.conference.metaFields && registration.conference.metaFields.length">-->
            <!--                        <h5 class="mt-5 mb-4">Additional Information</h5>-->

            <!--                        <b-form-row class="mt-2" v-for="field in registration.metaFields">-->
            <!--                            <b-col v-if="field.type === 'text'">-->
            <!--                                <b-form-group :description="field.help">-->
            <!--                                    <label>{{field.title}} <span class="required" v-if="field.required === 'true'">*</span></label>-->
            <!--                                    <b-form-input v-model="field.value" :required="field.required === 'true'"></b-form-input>-->
            <!--                                </b-form-group>-->
            <!--                            </b-col>-->
            <!--                            <b-col v-else-if="field.type === 'dropdown'">-->
            <!--                                <b-form-group :description="field.help">-->
            <!--                                    <label>{{field.title}} <span class="required" v-if="field.required === 'true'">*</span></label>-->
            <!--                                    <select class="form-control" v-model="field.value" :required="field.required === 'true'">-->
            <!--                                        <option v-for="option in getMetaFieldOptions(field.options)" :value="option">{{option}}</option>-->
            <!--                                    </select>-->
            <!--                                </b-form-group>-->
            <!--                            </b-col>-->
            <!--                            <b-col v-else-if="field.type === 'textarea'">-->
            <!--                                <b-form-group :description="field.help">-->
            <!--                                    <label>{{field.title}} <span class="required" v-if="field.required === 'true'">*</span></label>-->
            <!--                                    <b-textarea v-model="field.value" :required="field.required === 'true'"></b-textarea>-->
            <!--                                </b-form-group>-->
            <!--                            </b-col>-->
            <!--                        </b-form-row>-->
            <!--                    </div>-->

            <!--                <h5 class="mt-5 mb-4">Registration Type</h5>-->

            <!--                <b-form-row class="mt-2">-->
            <!--                    <b-col>-->
            <!--                        <select class="form-control" v-model="registration.fee">-->
            <!--                            <option v-for="fee in registration.conference.fees" :value="fee">{{fee.title}} ({{fee.fee | currency}})</option>-->
            <!--                        </select>-->
            <!--                    </b-col>-->
            <!--                </b-form-row>-->

            <!--<h5 class="mt-5 mb-4">Registration Extras</h5>-->

            <!--<b-form-row class="mt-2">-->
            <!--    <b-col>-->
            <!--        <b-form-checkbox></b-form-checkbox>-->
            <!--    </b-col>-->
            <!--</b-form-row>-->

            <h5 class="mt-5 mb-4">Registration Type</h5>

            <b-form-row class="mt-2">
                <b-col>
                    <select class="form-control" v-model="registration.fee">
                        <option v-for="fee in registration.conference.fees" :value="fee">{{fee.title}} ({{fee.fee | currency}})</option>
                    </select>
                </b-col>
            </b-form-row>

            <b-row>
                <b-col>
                    <b-button variant="success" class="mt-5" @click="updateReg"><i class="far fa-check mr-3"></i>Save Registration</b-button>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>


</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "reg-edit",
        props: ['id', 'code'],
        data: function () {
            return {
                registration: {
                    conference: {},
                    fee: {}
                },
                districts: [],
                schools: []
            }
        },
        methods: {
            ...mapActions(['getRegistrationByCode', 'getDistricts', 'updateRegistration']),

            updateReg() {

                let payload = {
                    first_name: this.registration.firstName,
                    last_name: this.registration.lastName,
                    phone_number: this.registration.phoneNumber,
                    email_address: this.registration.emailAddress,
                    address_1: this.registration.address1,
                    address_2: this.registration.address2,
                    city: this.registration.city,
                    state: this.registration.state,
                    zip: this.registration.zip,
                    fee_id: this.registration.fee.id
                }

                this.updateRegistration({id: this.code, data: payload}).then(() => {
                    this.$notify('success', 'Update Registration', 'Registration has been saved.', {duration: 5000, permanent: false});

                });
            }
        },
        mounted: function () {
            this.getRegistrationByCode(this.code).then(reg => {
                if (reg.phoneNumber) reg.phoneNumber = formatPhoneNumber(reg.phoneNumber);
                this.registration = reg;
            }, err => {
                console.error(err);
            });

            this.getDistricts().then(results => {
                this.districts = results;
            }, err => {
                console.error(err);
            });
        }
    }

    function formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3]
        }
        return null
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';


</style>
